import { render } from "./WindowsDownloadSubView.vue?vue&type=template&id=75020837&scoped=true"
import script from "./WindowsDownloadSubView.vue?vue&type=script&lang=js"
export * from "./WindowsDownloadSubView.vue?vue&type=script&lang=js"

import "./WindowsDownloadSubView.vue?vue&type=style&index=0&id=75020837&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75020837"]])

export default __exports__